import { dependency } from '../../utils/request';
import { getData } from '../../utils/data';
/**
 * @module directives/form/recaptcha
 */

/**
 * Enhances forms with Google reCAPTCHA functionality. Requires use of the reCAPTCHA Craft plugin.
 */
export default function recaptchaDirective() {
  const recaptchaPath = 'https://www.google.com/recaptcha/api.js',
  forms = document.querySelectorAll('form[data-sw-recaptcha]');
	if (forms.length > 0) {
		dependency(recaptchaPath, () => {
      if (!window.grecaptcha) return false;
      forms.forEach(form => {
        const recaptcha = form.querySelector('.g-recaptcha');
        const callbackName = form.getAttribute('data-sw-recaptcha');
				window[callbackName] = event => {
          const validator = getData(form, 'validator');
          const preSubmit = window.hsFormWillSubmit ? window.hsFormWillSubmit : ()=>{};
          if (validator) {
            validator.runSubmission(event, preSubmit);
          } else {
            preSubmit(); form.submit();
          }
          recaptcha.disabled = false;
          recaptcha.removeAttribute('disabled');
				}
			});
      return true;
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/recaptcha.js